/* eslint-disable @nx/enforce-module-boundaries */
import { Box } from '@mybridge/ui/layout';
import React, { useEffect } from 'react';
import {
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from '@mybridge/ui/popover';
import { Portal } from '@mybridge/ui/portal';
import { VerticalMoreIcon } from '@mybridge/icons';
import styles from './statusProfile.module.scss';
import { Button, HStack, VStack } from '@chakra-ui/react';
import { Text, Tooltip } from '@mybridge/ui';
import { ChatEmojiPicker } from './ChatEmojiPicker';
import { ReplyIcon } from '@mybridge/icons/ReplyIcon';
import { deleteSelectedRoomMessage } from 'v4/store/actions/global.data.actions';
import { useDispatch } from 'react-redux';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

const MessageOnOver = ({
  isSender,
  selectedMsg,
  setIsReply,
  setSelectedForwardMsg,
  setIsForwardMsgModal,
  getSelectedRoomMessagesData,
  addreaction,
  setEditingMessage,
  setIsEditMode
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslator();

  const handleEditMessage = () => {
    setIsEditMode(true);
    setEditingMessage(selectedMsg);
  };

  const deleteSelectedRoomMessages = () => {
    const payload = {
      room_id: `${selectedMsg.room_id}`,
      event_id: `${selectedMsg.event_id}`,
    };
    dispatch(deleteSelectedRoomMessage(payload)).then((res) => {
      getSelectedRoomMessagesData(null, false, { showLoader: false });
    });
  };



  return (
    <>
      {
        selectedMsg?.content && Object.keys(selectedMsg.content).length > 1 && <HStack gap={[0,0,0,2]} flexDir={isSender? ['column','row','row','row'] : 'row-reverse'} cursor="pointer">
          <ChatEmojiPicker addreaction={addreaction} selectedMsg={selectedMsg}/>
          <Box ml={isSender?[1,1,1,'10px']:[0,0,0,0]}>
            <Tooltip rounded={"lg"} variant="round" label={'Reply'} >
              <Box
                onClick={() =>
                  setIsReply({
                    isShowMsg: true,
                    selectedMsg: selectedMsg,
                  })
                }
              >
                <ReplyIcon />
              </Box>
            </Tooltip>
          </Box>
          <Box cursor="pointer">
            <Popover placement={isSender ? 'bottom-end' : 'right-start'} isLazy>
              <PopoverTrigger>
                <Button
                  _hover={{
                    background: 'transparent',
                  }}
                  backgroundColor={'transparent'}
                  marginLeft={[0,0,0,"2px"]}
                >
                  <VerticalMoreIcon />
                </Button>
              </PopoverTrigger>
              <Portal>
                <PopoverContent
                  bgColor={'#F9F9F9'}
                  marginTop={'0px'}
                  // padding={'16px'}
                  mt={'-12px'}
                  borderRadius={'16px'}
                  maxW="203px"
                  className={styles.statusDropdown}
                >
                  <PopoverBody
                    py={0}
                    px={'0px'}
                    style={{ outline: 'none', borderRadius: '12px' }}
                  >
                    <VStack alignItems="start" justifyContent="start" padding={'16px'}>
                      {isSender && selectedMsg?.content?.msgtype === "m.text" && (
                        <Text
                          color="#747474"
                          fontFamily="Inter"
                          fontWeight={400}
                          fontSize="15px"
                          width="100%"
                          _hover={{
                            color: '#464646',
                          }}
                          lineHeight="20px"
                          cursor="pointer"
                          onClick={handleEditMessage}
                        >
                          {' '}
                          {t('myCalendar.edit') || "Edit"}
                        </Text>
                      )}
                      {isSender && (<Text
                        color="#747474"
                        fontFamily="Inter"
                        cursor='pointer'
                        fontWeight={400}
                        width="100%"
                        _hover={{
                          color: '#464646',
                        }}
                        fontSize="15px"
                        lineHeight="20px"
                        onClick={() => deleteSelectedRoomMessages()}
                      >
                        {isSender ? t('myMessages.unsend') || 'Unsend' : t('profile.remove') || 'Remove'}
                      </Text>)}
                      <Text
                        color="#747474"
                        fontFamily="Inter"
                        fontWeight={400}
                        fontSize="15px"
                        cursor='pointer'
                        width="100%"
                        _hover={{
                          color: '#464646',
                        }}
                        lineHeight="20px"
                        onClick={()=>{
                          setIsForwardMsgModal(true);
                          setSelectedForwardMsg(selectedMsg);
                        }}
                      >
                        {' '}
                        {t('myMessages.forward') || "Forward"}
                      </Text>
                    </VStack>
                  </PopoverBody>
                </PopoverContent>
              </Portal>
            </Popover>
          </Box>
        </HStack>
      }
    </>
  );
};

export default MessageOnOver;
